import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';

const Loading = (props) => {
    if (!props.isLoading) {
        return null;
    }
    return (

        <div className="loading-overlay">
            <div className="loading-content">

                <CircularProgress size={80} thickness={5}/>
            </div>

        </div>
    );
};

Loading.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/layout/Loading.js